import { useStore } from "@nanostores/react"
import { atom, onMount } from "nanostores"

import config from "@/config"
import type { sdk } from "@/api/sdk"

const $isOneSignalLoaded = atom(false)
const $hasPushPermission = atom(false)
const $hasUserOptIn = atom(false)

onMount($isOneSignalLoaded, () => {
  console.log("OneSignal: Init ONESIGNAL_APP_ID:", config.ONESIGNAL_APP_ID)

  $isOneSignalLoaded.set(true)

  return () => {}
})

type OneSignalUserProfile = Pick<
  NonNullable<Awaited<ReturnType<typeof sdk.Me>>["me"]>,
  "id" | "email" | "phoneNumber" | "firstName" | "lastName" | "googleToken"
>

export const oneSignalIdentify = (oneSignalProfile: OneSignalUserProfile) => {
  console.log("onesignal disabled on web.", oneSignalProfile)
}

export const oneSignalLogout = () => {
  console.log("onesignal disabled on web. logout")
}

export const useOneSignalPermissions = () => {
  const hasPushPermission = useStore($hasPushPermission)
  const hasUserOptIn = useStore($hasUserOptIn)
  return {
    hasPushPermission,
    hasUserOptIn,
  }
}

export const useInitOneSignal = () => {
  return useStore($isOneSignalLoaded)
}

export const checkCanRequestOneSignalPermission = async () => {
  return false
}

export const requestOneSignalPermission = async () => {
  return false
}

export const oneSignalOptIn = () => {
  console.log("onesignal opt in")
}

export const oneSignalOptOut = () => {
  console.log("onesignal opt out")
}
